import { Backbone } from "extensions/backbone";

import { _parameterized } from "common/helpers/_parameterized";

// Collection where query params matter. Pazien parameterized collection stores daterange by default.
// Can be extended to use currency as well
export const ParameterizedCollection = Backbone.Collection.extend({
    ..._parameterized,
    constructor: function constructor(...args) {
        Backbone.Collection.call(this, ...args);
        this.resetParams();
    }
});
